"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proofOfBirthFactory = exports.proofOfBirthDocumentFactory = exports.legalInformationFactory = exports.approvalFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
const proof_of_birth_1 = require("../proof-of-birth");
const mocks_1 = require("../../../mocks");
exports.approvalFactory = Factory.Sync.makeFactory({
    affiliated_org_id: 2,
    date: mocks_1.dates.date2000,
    other_details: 'test',
    persona_id: mocks_1.persona.id,
    rejection_reason: undefined,
    status: proof_of_birth_1.ApprovalStatus.approved,
    user_id: 1,
});
exports.legalInformationFactory = Factory.Sync.makeFactory({
    date_of_birth: mocks_1.dates.date2000,
    first_name: mocks_1.persona.first_name,
    gender: mocks_1.persona.gender,
    last_name: mocks_1.persona.last_name,
    middle_name: null,
    suffix: null,
});
exports.proofOfBirthDocumentFactory = Factory.Sync.makeFactory({
    content_type: 'image/jpeg',
    date: mocks_1.dates.date2000,
    expiration_date: mocks_1.dates.date2100,
    name: 'https://example.com',
    s3_key: Factory.each(() => uuid_1.v4()),
    size: 12345,
    user_id: 1,
});
exports.proofOfBirthFactory = Factory.Sync.makeFactory({
    id: Factory.each(() => uuid_1.v4()),
    org_id: mocks_1.orgNgb.id,
    legal: exports.legalInformationFactory.build(),
    persona_id: mocks_1.persona.id,
    approval: exports.approvalFactory.build(),
    document: exports.proofOfBirthDocumentFactory.build(),
});
